import { render, staticRenderFns } from "./LeadsMain.vue?vue&type=template&id=1d3d77ba&"
import script from "./LeadsMain.vue?vue&type=script&lang=js&"
export * from "./LeadsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports